import { render, staticRenderFns } from "./statistik.vue?vue&type=template&id=0bdbc6da"
import script from "./statistik.vue?vue&type=script&lang=js"
export * from "./statistik.vue?vue&type=script&lang=js"
import style0 from "./statistik.vue?vue&type=style&index=0&id=0bdbc6da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports